import { InvoiceSummary } from 'api/invoice.types';
import { Price } from 'components/Price';
import { InvoicePaymentCard } from 'pages/Invoices/pages/InvoicePayment/components/InvoicePaymentCard';
import React from 'react';
import { ContentUtil } from 'utils/content';
import { DateFormat, dateUtils } from 'utils/date';
import { capitalizeFirstCharOfString } from 'utils/transformers';

import { content } from './invoice-payment-details.content';
import { CardBackground, Content, Hr, SpecificationRow } from './invoice-payment-details.styles';

const contentUtil = new ContentUtil({ content, componentName: 'InvoicePaymentDetails' });

interface InvoicePaymentDetailsProps {
  invoice: InvoiceSummary;
}

export const InvoicePaymentDetails = ({ invoice }: InvoicePaymentDetailsProps) => {
  const totalAmount = invoice.totalAmount || 0;
  const dueAmount = invoice.dueAmount || 0;
  const payedAmount = totalAmount - dueAmount;

  return (
    <>
      <Content>
        <Hr />
        <SpecificationRow>
          <span>{capitalizeFirstCharOfString(dateUtils.format(invoice.period, DateFormat.MONTH_YEAR))}</span>
          <span data-testid="price-totalAmount">
            <Price price={totalAmount} />
          </span>
        </SpecificationRow>
        {payedAmount > 0 && (
          <SpecificationRow>
            <span>{contentUtil.translate('payedAmount')}</span>
            <span data-testid="price-payedAmount">
              <Price price={payedAmount} />
            </span>
          </SpecificationRow>
        )}
        <Hr />
        <SpecificationRow>
          <strong>{contentUtil.translate('dueAmount')}</strong>
          <strong data-testid="price-dueAmount">
            <Price price={dueAmount} />
          </strong>
        </SpecificationRow>
      </Content>
      <CardBackground>
        <InvoicePaymentCard invoice={invoice} />
      </CardBackground>
    </>
  );
};
